import React, { useEffect, useState } from 'react';
import { Dialog, Form, InputNumber, MessagePlugin } from 'tdesign-react';
import Text from '@/components/Text';
import { updatePartitionNum } from '@/services/kopTopicService';
import { isEmpty } from '@/utils/common';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;
export default function AddPartionModal({ overview, visible, handleClose }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        clusterName: overview.clusterName,
        topic: overview.topic,
      });
    }
  }, [visible, form, overview]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      if (fields.partitionNum <= overview.topicPartitionCount) {
        MessagePlugin.warning('分区数量不能小于当前分区数量');
        return;
      }
      try {
        setSubmitting(true);
        await updatePartitionNum(fields);
        handleClose();
        MessagePlugin.success('操作成功，请稍后查看');
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      visible={visible}
      onClose={handleClose}
      confirmBtn={confirmBtn}
      onConfirm={() => form.submit()}
      header='分区扩容'
    >
      <Form form={form} onSubmit={handleSubmit}>
        <FormItem name='clusterName' label='集群名称'>
          <Text />
        </FormItem>
        <FormItem name='topic' label='Topic'>
          <Text />
        </FormItem>
        <FormItem
          label='分区数量'
          name='partitionNum'
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val > 0, message: '请输入大于0的值' },
            { validator: (val) => isEmpty(val) || val <= 1000, message: '分区数量不超过1000个' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
      </Form>
    </Dialog>
  );
}
